export const COLORS = {
  gray50: "#f2f2f2",
  gray80: "#dedede",
  green50: "#8FCC33",
  red50: "#C41E3A",
  white: "#FFFFFF",
  blue80: "#004ecc",
  black100: "#1F1D26",
};
